import { CreateIcon, DeleteIcon } from "../../../assets";

import Box from "@mui/material/Box";
import { CustomButton } from "../../../components";
import { CustomCard } from "../../../components/composedComponents/subscriptions/customCard";
import { IconButton } from "@mui/material";
import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import { isObjectEmpty } from "../../../utils";
import { withDialog, withDrawer } from "../../../HOC's";
import { Prompt } from ".";
import AddEmailDrawer from "../../../components/cards/addEmailAddressCard";
import ViewAllEmailType from "./viewAllEmailType";

const dynamicPx = { xs: 1.5, md: 1.5 };

function MultipleEmailAddress(props) {
  const {
    data: emailData = [],
    options = [],
    handleSave,
    handleDelete,
    helperText,
  } = props;

  // Handlers
  const handleCloseDrawer = () => {
    props.drawer.setDrawer({
      open: false,
      component: <></>,
    });
  };

  const handleSaveEmail = (data) => {
    handleCloseDrawer();
    handleSave(data);
  };

  const handleAddEditClick = (editData = null) => {
    debugger;
    props.drawer.setDrawer({
      open: true,
      component: (handleClose) => (
        <AddEmailDrawer
          isEdit={!!editData}
          editData={editData ?? {}}
          options={options}
          onSave={handleSaveEmail}
          handleClose={handleClose}
        />
      ),
    });
  };

  const handldeDeleteClick = (deletedEmail) => {
    props.dialog.setDialog({
      open: true,
      renderContent: (handleClose, handleAccept) => (
        <Prompt
          title={"Delete Email"}
          body={
            <>
              Are you sure, do you want to delete <br /> this Email?
            </>
          }
          handleClose={handleClose}
          handleAccept={handleAccept}
        />
      ),
      positiveButtonProps: {
        hide: true,
      },
      negativeButtonProps: {
        hide: true,
      },
      onAccept: () => handleDelete(deletedEmail),
      sx: {
        Dialog: {
          "&.MuiDialog-paper": {
            borderRadius: "12px",
          },
        },
        DialogContent: {
          "&.MuiDialogContent-root": {
            padding: 0,
          },
        },
      },
    });
  };

  const handleViewAllClick = () => {
    props.drawer.setDrawer({
      open: true,
      component: (handleClose) => (
        <ViewAllEmailType
          value={emailData}
          handleClose={handleClose}
          handleEditClick={handleAddEditClick}
          handldeDeleteClick={handldeDeleteClick}
        />
      ),
    });
  };

  return (
    <>
      <CustomCard
        {...props}
        required={props.required}
        titleSx={{ color: "text.primary", fontWeight: 500 }}
        stackSx={{ px: dynamicPx }}
        title={"Email Details"}
        helperText={helperText}
      >
        <Box
          sx={{
            pb: 1,
            bgcolor: (theme) => alpha(theme.palette.secondary.light, 0.1),
          }}
        >
          {!isObjectEmpty(emailData) && !props.isEdit && (
            <Box>
              {Array.isArray(emailData) &&
                emailData?.length > 0 &&
                emailData?.slice(0, 1)?.map((emailObject, index) => (
                  <Stack
                    gap={0}
                    sx={{
                      borderBottom: 1,
                      borderColor: "grey.border",
                      px: dynamicPx,
                      pt: 1,
                      bgcolor: "common.white",
                    }}
                  >
                    <>
                      <Stack
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ mb: 1 }}
                      >
                        <Stack>
                          <Typography color="textSecondary">
                            {emailObject?.email_type?.label}
                          </Typography>
                          <Typography
                            sx={{
                              color: "text.primary",
                            }}
                          >
                            {emailObject?.email}
                          </Typography>
                        </Stack>
                        <Stack
                          flexDirection="row"
                          alignItems="flex-end"
                          justifyContent="flex-end"
                          // sx={{ mb: 2 }}
                        >
                          <IconButton
                            onClick={() => handleAddEditClick(emailObject)}
                          >
                            <CreateIcon fontSize="small" sx={{fontSize: "16px"}} />
                          </IconButton>
                          <IconButton
                            onClick={() => handldeDeleteClick(emailObject)}
                          >
                            <DeleteIcon fontSize="small" sx={{fontSize: "16px"}} />
                          </IconButton>
                        </Stack>
                      </Stack>
                    </>
                  </Stack>
                ))}
            </Box>
          )}

          <Box sx={{ px: dynamicPx, pt: 1 }}>
            <Stack flexDirection={"row"} justifyContent={"space-between"}>
              <CustomButton
                variant="text"
                color="secondary"
                size="small"
                onClick={() => handleAddEditClick()}
              >
                + Add Email
              </CustomButton>
              {emailData?.length > 1 ? (
                <CustomButton
                  variant="text"
                  color="primary"
                  size="small"
                  onClick={handleViewAllClick}
                >
                  View Saved Email
                </CustomButton>
              ) : (
                <></>
              )}
            </Stack>
          </Box>
        </Box>
      </CustomCard>
    </>
  );
}

export default withDrawer(withDialog(MultipleEmailAddress));
